<!-- 返回首页  导航 -->
<template>
<div>
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }" class="back-home"><i class="el-icon-s-home"/> 首页</el-breadcrumb-item>
        <el-breadcrumb-item class="detail-name">{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
</div>
</template>

<script>
export default {
    name: 'breadcrumb',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue